import { render, staticRenderFns } from "./CompletenessGraph.vue?vue&type=template&id=9f8c3644&"
import script from "./CompletenessGraph.vue?vue&type=script&lang=ts&"
export * from "./CompletenessGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports